/**
 * Single source of truth for hostname → API base URL mapping.
 * Berlin uses the same mobile-like features/rules as live.mobile.
 */

const hostname = window.location.hostname;

const DOMAIN_API_MAP = [
  {
    webEnv: "REACT_APP_WEB_PARTS_URL",
    apiEnv: "REACT_APP_PARTS_URL",
    title: "Parts POS - BuyPhone24",
  },
  {
    webEnv: "REACT_APP_WEB_ACCESSORIES_URL",
    apiEnv: "REACT_APP_ACCESSORIES_URL",
    title: "Accessories POS - BuyPhone24",
    aggregate: { aggregate: "unique_identifier" },
  },
  {
    webEnv: "REACT_APP_WEB_MOBILE_URL",
    apiEnv: "REACT_APP_API_URL",
    title: "Mobile POS - BuyPhone24",
    mobileLike: true,
  },
  {
    webEnv: "REACT_APP_WEB_BERLIN_URL",
    apiEnv: "REACT_APP_BERLIN_URL",
    title: "Berlin Mobile POS - BuyPhone24",
    mobileLike: true,
  },
  {
    webEnv: "REACT_APP_WEB_LOYCOM_URL",
    apiEnv: "REACT_APP_LOYCOM_URL",
    title: "POS - Loycom",
  },
  {
    webEnv: "REACT_APP_WEB_HANDYWELT_URL",
    apiEnv: "REACT_APP_HANDYWELT_URL",
    title: "Handywelt POS",
    mobileLike: true,
    hideProductRamStorage: true,
  },
  {
    webEnv: "REACT_APP_WEB_ACCESSORIES_GODOWN_URL",
    apiEnv: "REACT_APP_ACCESSORIES_GODDOWN_URL",
    title: "POS System - BuyPhone24",
  },
];

const LOCAL_FALLBACK = {
  webEnv: "REACT_APP_LOCAL_URL",
  apiEnv: "REACT_APP_API_URL",
  title: "POS System - BuyPhone24",
};

export const resolveDomainConfig = () => {
  const match =
    DOMAIN_API_MAP.find(
      ({ webEnv }) => process.env[webEnv] && hostname === process.env[webEnv]
    ) ||
    (process.env.REACT_APP_LOCAL_URL && hostname === process.env.REACT_APP_LOCAL_URL
      ? LOCAL_FALLBACK
      : null);

  const baseURL = match ? process.env[match.apiEnv] || "" : "";
  const aggregate = match?.aggregate || {};

  return {
    hostname,
    baseURL,
    title: match?.title || "POS System - BuyPhone24",
    aggregate,
    isPartsURL: baseURL === process.env.REACT_APP_PARTS_URL,
    isAccessoriesURL: baseURL === process.env.REACT_APP_ACCESSORIES_URL,
    isMobileURL:
      baseURL === process.env.REACT_APP_API_URL ||
      baseURL === process.env.REACT_APP_BERLIN_URL,
    isBerlinURL: baseURL === process.env.REACT_APP_BERLIN_URL,
    isGodownURL: baseURL === process.env.REACT_APP_ACCESSORIES_GODDOWN_URL,
    isHandyweltURL: baseURL === process.env.REACT_APP_HANDYWELT_URL,
    isMobileLikeURL:
      Boolean(match?.mobileLike) ||
      baseURL === process.env.REACT_APP_API_URL ||
      baseURL === process.env.REACT_APP_BERLIN_URL ||
      baseURL === process.env.REACT_APP_HANDYWELT_URL,
    hideProductRamStorage: Boolean(match?.hideProductRamStorage),
  };
};

export const getDomainHostname = () => hostname;

export const MOBILE_LIKE_WEB_HOSTS = [
  process.env.REACT_APP_WEB_MOBILE_URL,
  process.env.REACT_APP_WEB_BERLIN_URL,
  process.env.REACT_APP_WEB_HANDYWELT_URL,
].filter(Boolean);

export const isMobileLikeWebDomain = (host = hostname) =>
  MOBILE_LIKE_WEB_HOSTS.includes(host);
